import React from 'react'
import { DASHBOARD_CONTEXT } from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'
import { FilterName, FilterParam } from '../../../FilterBar.types'
import { DashboardDimensionFilterDropdown } from './DashboardDimensionFilterDropdown'

export const DashboardCompanyFilterDropdown = ({
  isNested = false,
  dashboardContext,
  dashboardName,
}: {
  isNested?: boolean
  dashboardContext?: DASHBOARD_CONTEXT
  dashboardName?: string
}): JSX.Element | null =>
  dashboardContext !== undefined && dashboardName !== undefined ? (
    <DashboardDimensionFilterDropdown
      filterParam={FilterParam.DASHBOARD_COMPANY_DIMENSION}
      filterName={FilterName.DASHBOARD_COMPANY_DIMENSION}
      dashboardContext={dashboardContext}
      dashboardName={dashboardName}
      dimension="org_name"
      undefinedString="Unknown"
      isNested={isNested}
    />
  ) : null
